'use strict';

angular.module('DoohApps')
.factory('AppAdminFilterData', function () {
    var DataFilter = {};

    DataFilter.SetDefault = function () {
        DataFilter.AppFilter = {};
        DataFilter.AppFilter.Offset = 0;
        DataFilter.AppFilter.Count = 10;
        DataFilter.AppFilter.Text = '';
        DataFilter.AppFilter.CompanyId = 0;
        DataFilter.AppFilter.CompanyObject = null;
        DataFilter.AppFilter.state = 0;
        DataFilter.AppFilter.titleOrder = 1;
        DataFilter.AppFilter.stateOrder = 0;
        DataFilter.AppFilter.companyOrder = 0;
        DataFilter.AppFilter.versionOrder = 0;

        DataFilter.SelectedApplication = {};
    };
    DataFilter.SetDefault();

    DataFilter.Clear = function () {
        DataFilter.SetDefault();
    }

    DataFilter.prepSelectedApplication = function (callback, that) {
        DataFilter.SelectedApplication = that;
        callback(DataFilter.SelectedApplication);
    }

    return DataFilter;
});